@use "~theme/breakpoints";

.main {
  --footer-height: 44px;

  padding: 16px 8px calc(var(--footer-height) + 24px) 8px;
  width: 100%;

  @include breakpoints.desktop {
    padding: {
      top: 50px;
      bottom: calc(var(--footer-height) + 50px);
    }
  }
}
